import { render } from "./SysAdminDialog.vue?vue&type=template&id=32a4dc73"
import script from "./SysAdminDialog.vue?vue&type=script&lang=js"
export * from "./SysAdminDialog.vue?vue&type=script&lang=js"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__